import React, { useEffect, useState } from "react"
import { FaArrowAltCircleUp } from "react-icons/fa"
import scrollTo from "gatsby-plugin-smoothscroll"
import { Link } from "gatsby"

const Footer = () => {
  const [year, setYear] = useState()

  useEffect(() => {
    setYear(new Date().getFullYear())
  }, [])

  const footerStyle = {
    cursor: "pointer"
  }

  return (
    <footer className="footer bg-brown small text-center text-white-50">
      <FaArrowAltCircleUp className="h3" style={footerStyle} onClick={() => scrollTo("#top")} />
      <div className="container">Copyright © Safe Passage for Wildlife {year}</div>
      <div><Link className="text-decoration-none text-white" to="/privacy">Privacy Policy</Link></div>
      <div>Website: <a className="text-white" href="https://www.nolanjames.me">Nolan James</a></div>
    </footer>
  )
}

export default Footer
